import type { JSX } from 'react'

import { useUnit } from 'effector-react'
import { useTranslation } from 'react-i18next'
import { model as router } from '~/core/router'
import { AppTitle } from '~/shared/ui/components/AppTitle'
import { AuthLayout } from '~/widgets/auth'
import { FinalMessage } from '../../shared/ui'

export function Title(): JSX.Element {
  return <AppTitle t={['forgot_password', 'fail']} />
}

FailPage.displayName = 'FailPage'
export function FailPage(): JSX.Element {
  const { t } = useTranslation()
  const error = useUnit(router.$state) as string

  const message = t(error || 'something_went_wrong_error')
  const body = t('confirm_fail_message', { reason: message })

  return (
    <AuthLayout>
      <FinalMessage
        title={t('sorry')}
        body={body}
        button={t('sign_in')}
        to='/sign-in'
      />
    </AuthLayout>
  )
}
